import { render, staticRenderFns } from "./StatisticBox.vue?vue&type=template&id=1b69a2ef&scoped=true"
import script from "./StatisticBox.vue?vue&type=script&lang=js"
export * from "./StatisticBox.vue?vue&type=script&lang=js"
import style0 from "./StatisticBox.vue?vue&type=style&index=0&id=1b69a2ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b69a2ef",
  null
  
)

export default component.exports